import { render } from "./ItemAbilityCompendiumModal.vue?vue&type=template&id=5d8193cc"
import script from "./ItemAbilityCompendiumModal.vue?vue&type=script&lang=js"
export * from "./ItemAbilityCompendiumModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__